import { addInitialPluginsAndHydrate } from './utils/conditioner'
import 'react-loading-skeleton/dist/skeleton.css'

///////////////////////////////
// Dynamic Lazy Load Modules //
///////////////////////////////
addInitialPluginsAndHydrate(document.documentElement)
